package org.example.zone360.pages.players_Details.playersInfo

import org.example.zone360.components.debugPrintln
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCalendarDay
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaFutbol
import com.varabyte.kobweb.silk.components.icons.fa.FaLandmark
import com.varabyte.kobweb.silk.components.icons.fa.FaShirt
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.OptionalInputField
import org.example.zone360.components.OptionalInputIconField
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.ShimmerCircle
import org.example.zone360.components.StarRating
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.pages.coachDetails.coachInfo.captureElementAsPng
import org.example.zone360.pages.coachDetails.coachInfo.truncateWithEllipsis
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.extractTeamName
import org.example.zone360.utils.getAllTeams
import org.example.zone360.utils.getCurrentMilliseconds
import org.example.zone360.utils.getSinglePlayer
import org.example.zone360.utils.isEmptyFeild
import org.example.zone360.utils.isEmptyWeightHeight
import org.example.zone360.utils.updateUserData
import org.example.zone360.utils.updateUserWithTeam
import org.example.zone360.utils.uploadCoachImage
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
fun PlayerInfo(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    userId: String,
    showInfoOverlay: (Boolean) -> Unit = {},
    getPlayerInfo1: GetSinglePlayerData,
    updatePlayerInfo: (GetSinglePlayerData) -> Unit,
    toastMessageCall: (String) -> Unit,
    seasonId: String,
) {

    val scope = rememberCoroutineScope()
    var isAllEdit by remember { mutableStateOf(false) }
    var isImageUploading by remember { mutableStateOf(false) }
    var getPlayerInfo by remember { mutableStateOf(GetSinglePlayerData()) }
    var isNationalityEditing by remember { mutableStateOf(false) }
    var isAgeEditing by remember { mutableStateOf(false) }
    var isTeamEditing by remember { mutableStateOf(false) }
    var isEthnicityEditing by remember { mutableStateOf(false) }
    var isHeightEditing by remember { mutableStateOf(false) }
    var isWeightEditing by remember { mutableStateOf(false) }
    var isNumberEditing by remember { mutableStateOf(false) }
    var isPositionEditing by remember { mutableStateOf(false) }
    var isFootEditing by remember { mutableStateOf(false) }
    var isSecondaryEditing by remember { mutableStateOf(false) }
    var playerPosition by mutableStateOf("Select Position")
    var secondaryPosition by remember { mutableStateOf("Select Secondary Position") }
    var foot by mutableStateOf("Select Foot")
    var nationality by remember { mutableStateOf("") }
    var height by remember { mutableStateOf("") }
    var age by remember { mutableStateOf("") }
    var weight by remember { mutableStateOf("") }
    var number by remember { mutableStateOf("") }
    var ethnicity by remember { mutableStateOf("") }
    var isNicknameEditing by remember { mutableStateOf(false) }
    var nickname by remember { mutableStateOf("") }
    var isSavingPicture by remember { mutableStateOf(false) }
    var uploadedImageUrl by remember { mutableStateOf<String?>(null) }
    val teamOptions = AppGlobal.teamDataList.map { it.teamName }
    var selectedWeight by remember { mutableStateOf("lbs") }
    var selectedHeight by remember { mutableStateOf("ft") }
    var isSavingData by remember { mutableStateOf(false) }
    // Add with your other state declarations
    var isImageLoading by remember { mutableStateOf(true) }
    var hasImage by remember { mutableStateOf(false) }
    var selectedTeam by remember {
        mutableStateOf(
            if (getPlayerInfo.team.isNotBlank() && getPlayerInfo.team in teamOptions)
                getPlayerInfo.team
            else
                "" // still blank internally if not found
        )
    }

    scope.launch {

        getPlayerInfo = getPlayerInfo1
        nationality = getPlayerInfo.nationality
        age = getPlayerInfo.age
        height = getPlayerInfo.height.substringBefore(" ")
        selectedHeight = getPlayerInfo.height.substringAfter(" ").ifBlank { "in" }
        weight = getPlayerInfo.weight.substringBefore(" ")
        selectedWeight = getPlayerInfo.weight.substringAfter(" ").ifBlank { "lbs" }
        number = getPlayerInfo.number
        playerPosition = getPlayerInfo.position.ifBlank { "Select Position" }
        selectedTeam = getPlayerInfo.team
        foot = getPlayerInfo.foot.ifBlank { "Select Foot" }
        secondaryPosition = getPlayerInfo.secondaryPosition.ifBlank { "Select Secondary Position" }
        ethnicity = getPlayerInfo.ethnicity
        nickname = getPlayerInfo.nickName

    }
    // Replace your existing LaunchedEffect with this:
    LaunchedEffect(getPlayerInfo1.imageUrl) {
        isImageLoading = true

        if (getPlayerInfo1.imageUrl.isNotBlank()) {
            hasImage = true  // Image exists in database
            val fullUrl = if (getPlayerInfo1.imageUrl.startsWith("http")) {
                getPlayerInfo1.imageUrl
            } else {
                "${Res.Images.base_Image_Url}${getPlayerInfo1.imageUrl}?nocache=${getCurrentMilliseconds()}"
            }

            val jsImg = js("new Image()")
            jsImg.crossOrigin = "anonymous"
            jsImg.onload = {
                uploadedImageUrl = fullUrl
                isImageLoading = false
            }
            jsImg.onerror = {
                uploadedImageUrl = Res.Images.userIcon
                isImageLoading = false
                hasImage = false  // Image failed to load, treat as no image
            }
            jsImg.src = fullUrl
        } else {
            hasImage = false  // No image exists
            uploadedImageUrl = Res.Images.userIcon
            isImageLoading = false
        }
    }

//    LaunchedEffect(getPlayerInfo1.imageUrl) {
//        if (getPlayerInfo1.imageUrl.isNotBlank()) {
//            val jsImg = js("new Image()")
//            jsImg.crossOrigin = "anonymous"
//            jsImg.src =
//                "${Res.Images.base_Image_Url}${getPlayerInfo1.imageUrl}?nocache=${js("Date.now()")}"
//
//            jsImg.onload = {
//                uploadedImageUrl = jsImg.src as String
//            }
//
//            jsImg.onerror = {
//                uploadedImageUrl = Res.Images.userIcon
//            }
//        } else {
//            uploadedImageUrl = Res.Images.userIcon
//        }
//    }



    fun captureImage() {
        isSavingPicture = true
        isAllEdit = false
        isNationalityEditing = false
        isTeamEditing = false
        isAgeEditing = false
        isEthnicityEditing = false
        isHeightEditing = false
        isWeightEditing = false
        isNumberEditing = false
        isPositionEditing = false
        isFootEditing = false
        isSecondaryEditing = false
        isNicknameEditing = false

        scope.launch {

            delay(100)
            captureElementAsPng(
                elementId = Res.Id.coachInfoHeader,
                fileName = "${getPlayerInfo.firstName} ${getPlayerInfo.lastName}"
            )
            isSavingPicture = false
        }
    }
    LaunchedEffect(userId, seasonId) {
        //
        val teamsData = getAllTeams(
            clubName = AppGlobal.userData.organization,
            seasonID = AppGlobal.selectedSeasonId
        )
        AppGlobal.teamDataList.clear()
        AppGlobal.teamDataList.addAll(teamsData.data)


    }
    fun isProfileComplete(profile: GetSinglePlayerData): Boolean {
        return profile.nationality.isNotBlank() &&
                profile.height.isNotBlank() &&
                profile.ethnicity.isNotBlank() &&
                profile.age.isNotBlank() &&
                profile.weight.isNotBlank() &&
                profile.number.isNotBlank() &&
                profile.position.isNotBlank() &&
                profile.nickName.isNotBlank()
    }
//
    LaunchedEffect(getPlayerInfo1) {
        val completed = isProfileComplete(getPlayerInfo)
        showInfoOverlay(!completed)
        console.log("isProfileCompleted: $completed")
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundImage(url(Res.Images.player_profile_bd_wo_logo))
            .backgroundSize(BackgroundSize.Cover)
            .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
            .borderRadius(15.px)

            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.boxShadowColor.rgb
            )
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
            .padding(
                leftRight = 10.px,
                topBottom = if (breakpoint >= Breakpoint.LG) 20.px else 10.px
            ),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                //                .width(if (breakpoint <= Breakpoint.LG) 1360.px else 100.percent)
                .fillMaxHeight(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(
                modifier = Modifier.width(98.percent),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .padding(top = 10.px)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .gap(15.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.End
                    ) {

                        if (isAllEdit) {
                            if (isSavingData) {
                                // Show progress indicator while saving
                                ProgressIndicator(size = 20.px)
                            } else {
                                FaCheck(
                                    size = IconSize.LG,
                                    modifier = Modifier
                                        .cursor(Cursor.Pointer)
                                        .color(sitePalette.bodyBackgroundSecondary.rgb)
                                        .onClick {
                                            scope.launch {
                                                try {
                                                    isSavingData = true
                                                    val jsonData = """{
                                                    "organization": "${AppGlobal.userData.organization}",
                                                    "uid": "$userId",
                                                    "nationality": "$nationality",
                                                    "age": "$age",
                                                    "nickName": "${nickname.trim()}",
                                                    "ethnicity": "$ethnicity",
                                                    "height": "${if (height.isEmptyFeild()) "" else "$height $selectedHeight"}",
                                                    "weight": "${if (weight.isEmptyFeild()) "" else "$weight $selectedWeight"}",
                                                    "number": "$number",
                                                    "position": "${if (playerPosition == "Select Position") "" else (playerPosition)}",
                                                    "secondaryPosition": "${if (secondaryPosition == "Select Secondary Position") "" else (secondaryPosition)}",
                                                    "foot": "${if (foot == "Select Foot") "" else (foot)}"
                                                }"""
                                                    val updateResponse = updateUserData(jsonData)
                                                    val refreshed = getSinglePlayer(
                                                        domainType = "soccer",
                                                        language = "en",
                                                        userID = userId,
                                                        organization = AppGlobal.userData.organization,
                                                        seasonID = AppGlobal.selectedSeasonId
                                                    ).data

                                                    val isComplete =
                                                        refreshed.organization.isNotBlank() &&
                                                                refreshed.nationality.isNotBlank() &&
                                                                refreshed.age.isNotBlank() &&
                                                                refreshed.ethnicity.isNotBlank() &&
                                                                refreshed.height.isNotBlank() &&
                                                                refreshed.weight.isNotBlank() &&
                                                                refreshed.number.isNotBlank() &&
                                                                refreshed.position.isNotBlank() &&
                                                                refreshed.nickName.isNotBlank()

                                                    showInfoOverlay(!isComplete)
                                                    updatePlayerInfo(refreshed)

                                                    // Turn off edit modes
                                                    isAllEdit = false
                                                    isNationalityEditing = false
                                                    isAgeEditing = false
                                                    isTeamEditing = false
                                                    isEthnicityEditing = false
                                                    isHeightEditing = false
                                                    isWeightEditing = false
                                                    isNumberEditing = false
                                                    isPositionEditing = false
                                                    isFootEditing = false
                                                    isSecondaryEditing = false
                                                    isNicknameEditing = false
                                                } catch (ce: CancellationException) {
                                                    throw ce
                                                } catch (e: Throwable) {
                                                    debugPrintln("Failed to update player data")
                                                } finally {
                                                    isSavingData = false
                                                }
                                            }
                                        }
                                )
                            }

                        } else {
                            Image(
                                src = Res.Images.white_Pencil_Icon,
                                modifier = Modifier
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        isAllEdit = true
                                        isNationalityEditing = true
                                        isAgeEditing = true
                                        if (AppGlobal.userData.role == Strings.ADMIN || AppGlobal.userData.role == Strings.COACH) {
                                            isTeamEditing = true
                                        }
                                        isEthnicityEditing = true
                                        isHeightEditing = true
                                        isWeightEditing = true
                                        isNumberEditing = true
                                        isPositionEditing = true
                                        isFootEditing = true
                                        isSecondaryEditing = true
                                        isNicknameEditing = true
                                    }
                            )
                        }
                        if (isSavingPicture) {
                            ProgressIndicator(size = 20.px)
                        } else {
                            Image(
                                src = Res.Images.share_nodes_white,
                                modifier = Modifier
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        scope.launch {
                                            val missingFields = mutableListOf<String>()

                                            if (getPlayerInfo.imageUrl.isBlank()) missingFields.add(
                                                "Profile Image"
                                            )
                                            if (getPlayerInfo.nationality.isBlank()) missingFields.add(
                                                "Nationality"
                                            )
                                            if (getPlayerInfo.age.isBlank()) missingFields.add("Age")
                                            if (getPlayerInfo.ethnicity.isBlank()) missingFields.add(
                                                "Ethnicity"
                                            )
                                            if (getPlayerInfo.height.isEmptyWeightHeight()) missingFields.add(
                                                "Height"
                                            )
                                            if (getPlayerInfo.weight.isEmptyWeightHeight()) missingFields.add(
                                                "Weight"
                                            )
                                            if (getPlayerInfo.number.isBlank()) missingFields.add("Number")
                                            if (getPlayerInfo.position.isBlank()) missingFields.add(
                                                "Position"
                                            )
                                            if (getPlayerInfo.nickName.isBlank()) missingFields.add(
                                                "Nickname"
                                            )


                                            if (missingFields.isEmpty()) {
                                                captureImage()
                                            } else {
                                                val text =
                                                    "Please Add: ${missingFields.joinToString(", ")} to download the image"
                                                toastMessageCall(text)
                                                showToast(ToastID.ERROR)
                                            }
                                        }
                                    }
                            )

                        }

                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .flexWrap(FlexWrap.Wrap)
                            .margin(top = 10.px)
                    ) {
                        if (window.screen.width > 760) {
                            Box(modifier = Modifier) {
                                if (AppGlobal.userData.uid == getPlayerInfo.uid) {
                                    Row(
                                        Modifier.fillMaxWidth().padding(right = 7.px, top = 7.px)
                                            .zIndex(99)
                                            .align(Alignment.TopEnd),
                                        horizontalArrangement = Arrangement.End
                                    ) {
                                        if (!isImageUploading) {
                                            Image(
                                                src = Res.Images.camera_icon,
                                                modifier = Modifier.width(23.px)
                                                    .cursor(Cursor.Pointer)
                                                    .margin(top = (-8).px)
                                                    .onClick {
                                                        val input = document.getElementById(Res.Id.playerImage) as? HTMLInputElement
                                                        input?.click()
                                                    }
                                            )
                                        }
                                    }
                                }

                                if ((hasImage && isImageLoading) || isImageUploading)  {
                                    ShimmerCircle(
                                        modifier = Modifier.size(120.px).zIndex(999)
                                            .borderRadius(100.percent)
                                    )
                                } else {
                                    // Handle blank image properly
                                    val imageSrc = when {
                                        // If we have an uploaded URL and it's not blank
                                        !uploadedImageUrl.isNullOrBlank() && uploadedImageUrl != Res.Images.userIcon -> {
                                            uploadedImageUrl!!
                                        }
                                        // If player has an image URL in their data
                                        getPlayerInfo.imageUrl.isNotBlank() -> {
                                            if (getPlayerInfo.imageUrl.startsWith("http")) {
                                                getPlayerInfo.imageUrl
                                            } else {
                                                "${Res.Images.base_Image_Url}${getPlayerInfo.imageUrl}?nocache=${getCurrentMilliseconds()}"
                                            }
                                        }
                                        // Default: show user icon
                                        else -> {
                                            Res.Images.userIcon
                                        }
                                    }
                                    Img(
                                        src = imageSrc,
                                        alt = "Player Image",
                                        attrs = Modifier.width(120.px).height(120.px)
                                            .borderRadius(100.px).objectFit(ObjectFit.Cover)
                                            .toAttrs {
                                                attr("crossorigin", "anonymous")
                                                attr("loading", "eager")
                                                // Add fallback for broken images using JavaScript
                                                attr("onerror", "this.src='${Res.Images.userIcon}'")
                                            }
                                    )
                                }
                            }
                        }
                        else {
                            Row(
                                modifier = Modifier.fillMaxWidth().margin(bottom = 10.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(modifier = Modifier.margin(right = 10.px)) {
                                    if (AppGlobal.userData.uid == getPlayerInfo.uid) {
                                        Row(
                                            Modifier.fillMaxWidth()
                                                .padding(right = 5.px, top = 5.px)
                                                .zIndex(99).align(Alignment.TopEnd),
                                            horizontalArrangement = Arrangement.End
                                        ) {
                                            if (!isImageUploading) {
                                                Image(
                                                    src = Res.Images.camera_icon,
                                                    modifier = Modifier.width(23.px)
                                                        .cursor(Cursor.Pointer)
                                                        .margin(top = (-8).px)
                                                        .onClick {
                                                            val input = document.getElementById(Res.Id.playerImage) as? HTMLInputElement
                                                            input?.click()
                                                        }
                                                )
                                            }
                                        }
                                    }

                                    if ((hasImage && isImageLoading) || isImageUploading)  {
                                        ShimmerCircle(
                                            modifier = Modifier
                                                .width(100.px)
                                                .height(100.px)
                                                .borderRadius(100.percent)
                                        )
                                    } else {
                                        val imageSrc = when {
                                            !uploadedImageUrl.isNullOrBlank() && uploadedImageUrl != Res.Images.userIcon -> {
                                                uploadedImageUrl!!
                                            }
                                            getPlayerInfo.imageUrl.isNotBlank() -> {
                                                if (getPlayerInfo.imageUrl.startsWith("http")) {
                                                    getPlayerInfo.imageUrl
                                                } else {
                                                    "${Res.Images.base_Image_Url}${getPlayerInfo.imageUrl}"
                                                }
                                            }
                                            else -> Res.Images.userIcon
                                        }

                                        Img(
                                            src = imageSrc,
                                            alt = "Player Image",
                                            attrs = Modifier.width(100.px).height(100.px)
                                                .borderRadius(100.px).objectFit(ObjectFit.Cover)
                                                .toAttrs {
                                                    attr("crossorigin", "anonymous")
                                                    attr("onerror", "this.src='${Res.Images.userIcon}'")
                                                }
                                        )
                                    }
                                }
                                Column(modifier = Modifier) {
                                    FieldTitleTextNormalSimple(
                                        text = "${getPlayerInfo.firstName} ${getPlayerInfo.lastName}",
                                        fontSize = 17.px,
                                        fontWeight = 600,
                                        color = Palette.White.rgbLight,
                                        fontFamily = Constants.IBM_FONT,
                                        wordBreak = WordBreak.BreakAll,
                                        marginBottom = 10.px
                                    )
                                    Row(
                                        modifier = Modifier.gap(5.px).flexWrap(FlexWrap.Wrap)
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text = "Rating:",
                                            fontSize = 14.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                        )
                                        StarRating(
                                            rating = getPlayerInfo.rating,
                                            onRatingChanged = {},
                                            size = 9.px,
                                            gap = 11.px,
                                            color = sitePalette.modalBackgroundColor.rgb
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = "(${getPlayerInfo.reviewCount})",
                                            fontSize = 14.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            wordBreak = WordBreak.BreakAll,
                                            marginLeft = 8.px
                                        )

                                    }
                                }
                            }
                        }
                        Column(
                            modifier = Modifier.margin(
                                left = if (breakpoint >= Breakpoint.MD) 20.px else 10.px,
                                right = 8.px
                            )
                                .weight(1.0)
                        ) {
                            if (window.screen.width > 760) {
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .flexWrap(FlexWrap.Wrap),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "${getPlayerInfo.firstName} ${getPlayerInfo.lastName}",
                                        fontSize = 20.px,
                                        fontWeight = 600,
                                        color = Palette.White.rgbLight,
                                        wordBreak = WordBreak.BreakAll,
                                        fontFamily = Constants.IBM_FONT
                                    )
                                    CustomSpacer(150.px)
                                    Row(
                                        modifier = Modifier.gap(5.px).flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text = "Rating:",
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px
                                        )
                                        StarRating(
                                            rating = getPlayerInfo.rating,
                                            onRatingChanged = {},
                                            color = sitePalette.modalBackgroundColor.rgb
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = "( ${getPlayerInfo.reviewCount} ${if (getPlayerInfo.reviewCount == 1) "Review" else "Reviews"})",
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            wordBreak = WordBreak.BreakAll,
                                            marginLeft = 8.px
                                        )

                                    }
                                }
                            }
                            Row(
                                modifier = Modifier.fillMaxWidth()
                                    .flexWrap(FlexWrap.Wrap),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Column(
                                    Modifier.gap(15.px)
                                        .margin(topBottom = 10.px)
                                        .width(
                                            if (window.screen.width > 1350) 33.percent
                                            else if (window.screen.width in 750..1349) 49.percent
                                            else 100.percent
                                        )
                                ) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth()
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier,
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaFutbol(modifier = Modifier.color(Palette.White.rgbLight))
                                            FieldTitleTextNormalSimple(
                                                text = getPlayerInfo.organization.replaceFirstChar
                                                { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                                fontSize = 16.px,
                                                wordBreak = WordBreak.BreakAll,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint <= Breakpoint.MD) 10.px else 40.px)
                                            .flexWrap(FlexWrap.Wrap)
                                            .fillMaxWidth(),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(120.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Image(src = Res.Images.nationalityFlag_white)
                                            FieldTitleTextNormalSimple(
                                                text = " Nationality: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px
                                            )
                                        }
                                        if (isNationalityEditing) {
                                            OptionalInputField(
                                                value = nationality,
                                                onValueChange = { nationality = it },
                                                placeHolder = "Enter Nationality",
                                                backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                width = 150.px,
                                                fontSize = 13.px,
                                                id = Res.Id.updateNationality
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = nationality,
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint <= Breakpoint.MD) 10.px else 40.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(120.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Image(src = Res.Images.heightMeasure_white)
                                            FieldTitleTextNormalSimple(
                                                text = "Height: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px
                                            )
                                        }
                                        if (isHeightEditing) {
                                            OptionalInputIconField(
                                                value = height,
                                                onValueChange = { height = it },
                                                placeHolder = "5.8",
                                                width = 150.px,
                                                fontSize = 13.px,
                                                number = true,
                                                leftRightPadding = 0.px,
                                                id = Res.Id.updateHeight,
                                                trailingIcon = {
                                                    CommonDropdown(
                                                        data = listOf("ft", "in", "cm"),
                                                        selectedItem = selectedHeight,
                                                        onSelect = { selectedHeight = it },
                                                        width = 100.percent,
                                                        leftRightPadding = 10.px,
                                                        height = 39.px
                                                    )
                                                }
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = "$height ${if (height.isBlank()) "" else selectedHeight}",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                wordBreak = WordBreak.BreakAll,
                                                color = Palette.White.rgbLight,
                                            )
                                        }

                                    }
                                }

                                Column(
                                    Modifier.gap(15.px)
                                        .margin(topBottom = if (breakpoint < Breakpoint.MD) {
                                            // Check if ANY edit mode is active on mobile
                                            if (isNicknameEditing || isEthnicityEditing || isWeightEditing) {
                                                5.px  // No margin when editing
                                            } else {
                                                10.px // Margin when not editing
                                            }
                                        } else {
                                            10.px // Always margin on desktop
                                        })
                                        .width(
                                            if (window.screen.width > 1350) 26.percent
                                            else if (window.screen.width in 750..1349) 49.percent
                                            else 100.percent
                                        ),
                                )
                                {
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint <= Breakpoint.MD) 30.px else if (window.screen.width in 900..1300) 58.px else 5.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    )
                                    {
                                        Row(
                                            modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 10.px else 5.px)
                                                .flexWrap(FlexWrap.Wrap),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Row(
                                                modifier = Modifier.width(120.px),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                FaUser(
                                                    modifier = Modifier.color(Palette.White.rgbLight),
                                                    size = IconSize.X1, style = IconStyle.FILLED
                                                )
                                                FieldTitleTextNormalSimple(
                                                    text = "Nickname:",
                                                    fontSize = 16.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = Palette.White.rgbLight,
                                                    marginLeft = 8.px
                                                )
                                            }
                                            if (isNicknameEditing) {
                                                OptionalInputField(
                                                    value = nickname,
                                                    onValueChange = { nickname = it.trim() },
                                                    placeHolder = "Enter Nickname",
                                                    backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                    width = if (breakpoint <= Breakpoint.MD) 150.px else 120.px,
                                                    fontSize = 13.px,
                                                    id = Res.Id.updateNickname
                                                )
                                            } else {
                                                FieldTitleTextNormalSimple(
                                                    text = nickname,
                                                    fontSize = 16.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = Palette.White.rgbLight,
                                                    wordBreak = WordBreak.BreakAll
                                                )
                                            }
                                        }

                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 30.px else 25.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(100.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaLandmark(Modifier.color(Palette.White.rgbLight))
                                            FieldTitleTextNormalSimple(
                                                text = "Ethnicity: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px,
                                            )
                                        }
                                        if (isEthnicityEditing) {
                                            OptionalInputField(
                                                value = ethnicity,
                                                onValueChange = { ethnicity = it },
                                                placeHolder = "Enter Ethnicity",
                                                backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                width = if (breakpoint <= Breakpoint.MD) 150.px else 120.px,
                                                fontSize = 13.px,
                                                id = Res.Id.updateEthnicity
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = ethnicity,
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 30.px else 25.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(100.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Image(
                                                src = Res.Images.weightMeasurement_white,
                                                modifier = Modifier.size(20.px)
                                            )
                                            FieldTitleTextNormalSimple(
                                                text = "Weight: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px,
                                            )
                                        }
                                        if (isWeightEditing) {
                                            OptionalInputIconField(
                                                value = weight,
                                                onValueChange = { weight = it },
                                                placeHolder = "12",
                                                leftRightPadding = 0.px,
                                                width = if (breakpoint <= Breakpoint.MD) 150.px else 120.px,
                                                fontSize = 13.px,
                                                decimalLimit = 2,
                                                id = Res.Id.updateWeight,
                                                number = true,
                                                trailingIcon = {
                                                    CommonDropdown(
                                                        data = listOf("lbs", "kg", "oz"),
                                                        selectedItem = selectedWeight,
                                                        onSelect = { selectedWeight = it },
                                                        width = 100.percent,
                                                        leftRightPadding = 10.px,
                                                        height = 39.px,
                                                    )
                                                }
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = "$weight ${if (weight.isBlank()) "" else selectedWeight}",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll
                                            )
                                        }

                                    }
                                }

                                Column(
                                    Modifier.gap(15.px)
                                        .margin(topBottom = if (breakpoint < Breakpoint.LG) if (isAllEdit) 10.px else 5.px else 10.px)
                                        .width(
                                            if (window.screen.width > 1350) 25.percent
                                            else if (window.screen.width in 750..1349) 49.percent
                                            else 100.percent
                                        )
                                )
                                {
                                    val gapValue = when {
                                        breakpoint < Breakpoint.LG -> 110.px
                                        breakpoint == Breakpoint.LG -> if (isAllEdit) 140.px else 130.px
                                        else -> 5.px
                                    }
                                    Row(
                                        modifier = Modifier.gap(gapValue)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    )
                                    {
                                        Image(
                                            src = Res.Images.teamIcon_white,
                                            modifier = Modifier.width(20.px).height(20.px)
                                        )
                                        if (isTeamEditing) {
                                            CommonDropdown(
                                                data = teamOptions, // add visual placeholder
                                                onSelect = { newTeam ->
                                                    if (newTeam != "Select Team") {
                                                        selectedTeam = newTeam
                                                        val teamID =
                                                            AppGlobal.teamDataList.firstOrNull { it.teamName == newTeam }?.id
                                                                ?: selectedTeam
                                                        scope.launch {

                                                            val response = updateUserWithTeam(
                                                                teamName = teamID,
                                                                userID = userId,
                                                                organization = AppGlobal.userData.organization,
                                                                isRemove = false
                                                            )
                                                            if (response.data == "Team added successfully!") {
                                                                getPlayerInfo =
                                                                    getPlayerInfo.copy(team = newTeam)
                                                            }
                                                        }
                                                    }
                                                },
                                                selectedItem = selectedTeam.ifBlank { "Select Team" },
                                                width = if (window.screen.width > 1400) 170.px else 150.px,
                                                height = 39.px,
                                            )

                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = getPlayerInfo.teams
                                                    .firstOrNull { it.seasonID == AppGlobal.selectedSeasonId }
                                                    ?.teamID?.extractTeamName() ?: "-",
                                                fontSize = 16.px,
                                                wordBreak = WordBreak.BreakAll,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = if (breakpoint <= Breakpoint.MD) 0.px else 8.px
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint <= Breakpoint.MD) 30.px else if (window.screen.width in 900..1300) 58.px else 5.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(100.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaCalendarDay(modifier = Modifier.color(Colors.White))
                                            FieldTitleTextNormalSimple(
                                                text = "Year Born: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px,
                                            )
                                        }
                                        if (isAgeEditing) {
                                            OptionalInputField(
                                                value = age,
                                                onValueChange = { age = it },
                                                placeHolder = "2025",
                                                backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                width = if (breakpoint <= Breakpoint.MD || breakpoint == Breakpoint.LG) 150.px else 90.px,
                                                fontSize = 13.px,
                                                number = true,
                                                id = Res.Id.updateAge
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = age,
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.gap(if (breakpoint <= Breakpoint.MD) 30.px else if (window.screen.width in 900..1300) 58.px else 5.px)
                                            .flexWrap(FlexWrap.Wrap),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(
                                            modifier = Modifier.width(100.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaShirt(modifier = Modifier.color(Colors.White))
                                            FieldTitleTextNormalSimple(
                                                text = "Number: ",
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                marginLeft = 8.px,
                                            )
                                        }
                                        if (isNumberEditing) {
                                            OptionalInputField(
                                                value = number,
                                                onValueChange = { number = it },
                                                placeHolder = "10",
                                                backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                width = if (breakpoint <= Breakpoint.MD || breakpoint == Breakpoint.LG) 150.px else 90.px,
                                                fontSize = 13.px,
                                                number = true,
                                                id = Res.Id.updateNumber
                                            )
                                        } else {
                                            FieldTitleTextNormalSimple(
                                                text = number,
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll
                                            )
                                        }
                                    }
                                }

                            }

                        }
                    }
                    Row(
                        modifier = Modifier.margin(topBottom = 10.px)
                            .flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier.width(271.px)
                                .height(182.px)
                                .zIndex(9)
                                .backgroundColor(Palette.FieldBackColor.rgbLight)
                                .overflow(overflowY = Overflow.Hidden, overflowX = Overflow.Auto)
                                .margin(topBottom = 10.px),
                            contentAlignment = Alignment.Center
                        ) {
                            //
                            Box(
                                modifier = Modifier.width(254.px).height(165.px)
                                    .zIndex(99)
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxSize().gap(5.px)
                                        .flexWrap(FlexWrap.Wrap),
                                    verticalAlignment = Alignment.CenterVertically,
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .backgroundColor(
                                                if (playerPosition == "GK Goalkeeper") Palette.AbsoluteGreen.rgbLight
                                                else if (secondaryPosition == "GK Goalkeeper") Palette.AbsoluteOrange.rgbLight
                                                else Colors.Transparent
                                            )
                                            .width(31.px).height(73.px)
                                    )
                                    Column(
                                        modifier = Modifier.gap(5.px).flexWrap(FlexWrap.Wrap)
                                            .margin(top = 2.px)
                                    ) {
                                        Box(
                                            modifier = Modifier
                                                .backgroundColor(
                                                    if (playerPosition == "LLD Left Lateral Defender") Palette.AbsoluteGreen.rgbLight
                                                    else if (secondaryPosition == "LLD Left Lateral Defender") Palette.AbsoluteOrange.rgbLight
                                                    else Colors.Transparent
                                                )
                                                .width(86.px).height(28.px)
                                        )
                                        Row(Modifier.gap(4.px)) {
                                            Column(Modifier.gap(4.px)) {
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "LCD Left Central Defender") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "LCD Left Central Defender") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(42.px).height(47.px)
                                                )
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "RCD Right Central Defender") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "RCD Right Central Defender") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(42.px).height(45.px)
                                                )
                                            }
                                            Box(
                                                modifier = Modifier
                                                    .backgroundColor(
                                                        if (playerPosition == "DM Defensive Midfielder") Palette.AbsoluteGreen.rgbLight
                                                        else if (secondaryPosition == "DM Defensive Midfielder") Palette.AbsoluteOrange.rgbLight
                                                        else Colors.Transparent
                                                    )
                                                    .width(40.px).height(96.px)
                                            )
                                        }
                                        Box(
                                            modifier = Modifier
                                                .backgroundColor(
                                                    if (playerPosition == "RLD Right Lateral Defender") Palette.AbsoluteGreen.rgbLight
                                                    else if (secondaryPosition == "RLD Right Lateral Defender") Palette.AbsoluteOrange.rgbLight
                                                    else Colors.Transparent
                                                )
                                                .width(86.px).height(28.px)
                                        )
                                    }
                                    Column(
                                        modifier = Modifier.gap(5.px).flexWrap(FlexWrap.Wrap)
                                            .margin(left = 2.px, top = 2.px)
                                    ) {
                                        Box(
                                            modifier = Modifier
                                                .backgroundColor(
                                                    if (playerPosition == "LW Left Wing") Palette.AbsoluteGreen.rgbLight
                                                    else if (secondaryPosition == "LW Left Wing") Palette.AbsoluteOrange.rgbLight
                                                    else Colors.Transparent
                                                )
                                                .width(82.px).height(28.px)
                                        )
                                        Row(Modifier.gap(4.px)) {
                                            Box(
                                                modifier = Modifier
                                                    .backgroundColor(
                                                        if (playerPosition == "AM Attacking Midfielder") Palette.AbsoluteGreen.rgbLight
                                                        else if (secondaryPosition == "AM Attacking Midfielder") Palette.AbsoluteOrange.rgbLight
                                                        else Colors.Transparent
                                                    )
                                                    .width(43.px).height(96.px)
                                            )
                                            Box(
                                                modifier = Modifier
                                                    .backgroundColor(
                                                        if (playerPosition == "ST Striker") Palette.AbsoluteGreen.rgbLight
                                                        else if (secondaryPosition == "ST Striker") Palette.AbsoluteOrange.rgbLight
                                                        else Colors.Transparent
                                                    )
                                                    .width(43.px).height(96.px)
                                            )

                                        }
                                        Box(
                                            modifier = Modifier
                                                .backgroundColor(
                                                    if (playerPosition == "RW Right Wing") Palette.AbsoluteGreen.rgbLight
                                                    else if (secondaryPosition == "RW Right Wing") Palette.AbsoluteOrange.rgbLight
                                                    else Colors.Transparent
                                                )
                                                .width(82.px).height(28.px)
                                        )
                                    }

                                }
                            }
                            Box(
                                modifier = Modifier.width(254.px).height(165.px)
                                    .backgroundImage(url(Res.Images.field_boundary))
                                    .zIndex(999)
                                    .backgroundSize(BackgroundSize.Cover)
                                    .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
                            )
                        }

                        Column(
                            modifier = Modifier.margin(left = if (breakpoint >= Breakpoint.MD) 24.px else 10.px)
                                .gap(if (window.screen.width < 760) 8.px else 15.px)
                        ) {
                            Column {
                                Row(
                                    modifier = Modifier.gap(10.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "Position:",
                                        color = Palette.White.rgbLight,
                                        fontWeight = 500,
                                        fontSize = 14.px,
                                        marginBottom = 4.px
                                    )
                                }
                                Row(
                                    modifier = Modifier.gap(5.px).flexWrap(FlexWrap.Wrap),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    if (isPositionEditing) {
                                        Box {
                                            CommonDropdown(
                                                data = listOf(
                                                    "Select Position",
                                                    "GK Goalkeeper",
                                                    "RCD Right Central Defender",
                                                    "LCD Left Central Defender",
                                                    "RLD Right Lateral Defender",
                                                    "LLD Left Lateral Defender",
                                                    "DM Defensive Midfielder",
                                                    "AM Attacking Midfielder",
                                                    "LW Left Wing",
                                                    "RW Right Wing",
                                                    "ST Striker"
                                                ).filter { it != secondaryPosition },
                                                onSelect = { selectedItem ->
                                                    playerPosition = selectedItem

                                                },
                                                selectedItem = playerPosition,
                                                width = if (window.screen.width > 375) 250.px else 100.percent,
                                            )
                                        }
                                    } else {
                                        FieldTitleTextNormalSimple(
                                            text = playerPosition,
                                            color = Palette.PrimaryPosition.rgbLight,
                                            fontWeight = 600,
                                            fontSize = 16.px,
                                            width = if (window.screen.width > 375) 250.px else 100.percent,
                                            whiteSpace = WhiteSpace.PreWrap,
                                            wordBreak = WordBreak.BreakAll,

                                            )
                                    }
                                }
                            }
                            Column {
                                Row(
                                    modifier = Modifier.gap(10.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "Secondary:",
                                        color = Palette.White.rgbLight,
                                        fontWeight = 500,
                                        fontSize = 14.px,
                                        marginBottom = 4.px
                                    )
                                }
                                if (isSecondaryEditing) {
                                    Box {
                                        CommonDropdown(
                                            data = listOf(
                                                "Select Secondary Position",
                                                "GK Goalkeeper",
                                                "RCD Right Central Defender",
                                                "LCD Left Central Defender",
                                                "RLD Right Lateral Defender",
                                                "LLD Left Lateral Defender",
                                                "DM Defensive Midfielder",
                                                "AM Attacking Midfielder",
                                                "LW Left Wing",
                                                "RW Right Wing",
                                                "ST Striker"
                                            ).filter { it != playerPosition }, // Exclude primary selection
                                            onSelect = { selectedItem ->
                                                secondaryPosition = selectedItem
                                            },
                                            selectedItem = secondaryPosition,
                                            width = if (window.screen.width > 375) 250.px else 100.percent,

                                            )
                                    }
                                } else {
                                    FieldTitleTextNormalSimple(
                                        text = secondaryPosition,
                                        color = Palette.AbsoluteOrange.rgbLight,
                                        fontWeight = 600,
                                        width = if (window.screen.width > 375) 250.px else 100.percent,
                                        fontSize = 16.px,
                                        whiteSpace = WhiteSpace.PreWrap
                                    )
                                }
                            }
                            Column {
                                Row(
                                    modifier = Modifier.gap(10.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "Foot:",
                                        color = Palette.White.rgbLight,
                                        fontWeight = 500,
                                        fontSize = 14.px,
                                        marginBottom = 4.px
                                    )
                                }
                                if (isFootEditing) {
                                    Box {
                                        CommonDropdown(
                                            data = listOf(
                                                "Select Foot",
                                                "Both Feet",
                                                "Right Foot",
                                                "Left Foot"
                                            ),
                                            onSelect = { selectedItem ->
                                                foot = selectedItem

                                            },
                                            selectedItem = foot,
                                            width = if (window.screen.width > 375) 250.px else 100.percent,

                                            )
                                    }
                                } else {
                                    FieldTitleTextNormalSimple(
                                        text = foot,
                                        color = Palette.White.rgbLight,
                                        fontWeight = 600,
                                        fontSize = 16.px,
                                        wordBreak = WordBreak.BreakAll,
                                        width = 100.percent
                                    )
                                }
                            }
                        }
                        if (window.screen.width > 770) {
                            Box(modifier = Modifier.align(Alignment.Bottom)) {
                                Image(src = Res.Images.website_logo_zone360_trans)
                            }
                        }
                    }
                    if (window.screen.width < 770) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.End
                        ) {
                            Image(src = Res.Images.website_logo_zone360_trans)
                        }
                    }
                }
            }


            Box(
                modifier = Modifier.width(500.px)
                    .backgroundImage(
                        linearGradient(
                            LinearGradient.Direction.ToBottomRight,
                            sitePalette.playerHeaderGradientOne.rgb,
                            sitePalette.playerHeaderGradientTwo.rgb
                        )
                    )
                    .boxShadow(
                        offsetY = 1.px,
                        blurRadius = 3.px,
                        color = sitePalette.boxShadowColor.rgb
                    )
                    .id(Res.Id.playerInfoHeader)
                    .position(Position.Absolute)
                    .left((-9999).px)
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth()
                        .backgroundImage(url(Res.Images.player_Bg_Vector))
                        .backgroundSize(BackgroundSize.Cover)
                        .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(
                                leftRight = 15.px,
                                topBottom = 20.px
                            )
                            .gap(10.px)
                            .fillMaxHeight(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Row(modifier = Modifier.fillMaxWidth().gap(16.px)) {
                            if (getPlayerInfo.imageUrl.isBlank()) {
                                Image(
                                    src = Res.Images.userIcon,
                                    modifier = Modifier.width(120.px).height(120.px)
                                        .borderRadius(100.px)
                                )
                            } else {
                                val imageSrc = uploadedImageUrl
                                    ?: "${Res.Images.base_Image_Url}${getPlayerInfo.imageUrl}"

                                Img(
                                    src = imageSrc,
                                    alt = "Player Image",
                                    attrs = Modifier.width(120.px).height(120.px)
                                        .borderRadius(100.px)
                                        .toAttrs()
                                    //                                        .toAttrs {
                                    //                                            attr("crossorigin", "anonymous")
                                    //                                        }
                                )

                            }
                            Column(Modifier.weight(1).gap(12.px)) {
                                FieldTitleTextNormalSimple(
                                    text = "${getPlayerInfo.firstName} ${getPlayerInfo.lastName}",
                                    fontSize = 32.px,
                                    fontWeight = 600,
                                    color = Palette.White.rgbLight,
                                    wordBreak = WordBreak.BreakAll,
                                    fontFamily = Constants.IBM_FONT
                                )
                                Row(
                                    Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    StarRating(
                                        rating = getPlayerInfo.rating,
                                        onRatingChanged = {},
                                        color = sitePalette.modalBackgroundColor.rgb
                                    )
                                    FieldTitleTextNormalSimple(
                                        text = "( ${getPlayerInfo.reviewCount} ${if (getPlayerInfo.reviewCount == 1) "Review" else "Reviews"})",
                                        fontSize = 16.px,
                                        fontFamily = Constants.IBM_FONT,
                                        color = Palette.White.rgbLight,
                                        wordBreak = WordBreak.BreakAll,
                                        marginLeft = 8.px
                                    )
                                }

                                Row(
                                    Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FaFutbol(modifier = Modifier.color(Palette.White.rgbLight))
                                    FieldTitleTextNormalSimple(
                                        text = getPlayerInfo.organization.uppercase(),
                                        fontSize = 16.px,
                                        fontFamily = Constants.IBM_FONT,
                                        color = Palette.White.rgbLight,
                                        wordBreak = WordBreak.BreakAll,
                                        marginLeft = 8.px
                                    )
                                }

                            }

                        }
                        Box(
                            modifier = Modifier.fillMaxWidth()
                                .borderRadius(11.92.px)
                                .zIndex(999)
                                .backgroundColor(sitePalette.playerSavePngDataBox.rgb)
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth()
                                    .padding(8.51.px),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(Modifier.gap(19.px)) {
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(
                                            src = Res.Images.teamIcon_white,
                                            modifier = Modifier.width(14.px).height(14.px)
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = getPlayerInfo.team.ifEmpty { "-" },
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            wordBreak = WordBreak.BreakAll,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px
                                        )
                                    }
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(src = Res.Images.nationalityFlag_white)
                                        FieldTitleTextNormalSimple(
                                            width = 80.px,
                                            text = nationality.truncateWithEllipsis(80, 16),
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px,
                                            wordBreak = WordBreak.BreakAll,
                                        )
                                    }
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        FaCalendarDay(modifier = Modifier.color(Colors.White))
                                        FieldTitleTextNormalSimple(
                                            width = 80.px,
                                            text = age.truncateWithEllipsis(80, 16),
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px,
                                            wordBreak = WordBreak.BreakAll,
                                        )

                                    }
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(src = Res.Images.heightMeasure_white)

                                        FieldTitleTextNormalSimple(
                                            "$height ${if (height.isBlank()) "" else selectedHeight}",
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px,
                                            wordBreak = WordBreak.BreakAll,
                                        )

                                    }
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(
                                            src = Res.Images.weightMeasurement_white,
                                            modifier = Modifier.size(20.px)
                                        )

                                        FieldTitleTextNormalSimple(
                                            width = 80.px,
                                            text = "${
                                                weight.truncateWithEllipsis(
                                                    80,
                                                    16
                                                )
                                            } ${if (weight.isBlank()) "" else selectedWeight}",
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            wordBreak = WordBreak.BreakAll,
                                            marginLeft = 8.px
                                        )

                                    }
                                    Row(
                                        modifier = Modifier.gap(5.px),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(
                                            src = Res.Images.foot_icon_white,
                                            modifier = Modifier.size(20.px)
                                        )

                                        FieldTitleTextNormalSimple(
                                            text = if (foot == "Select Foot") "" else foot,
                                            fontSize = 16.px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            marginLeft = 8.px
                                        )

                                    }

                                }
                                Box(
                                    modifier = Modifier.width(271.px)
                                        .height(182.px)
                                        .zIndex(9)
                                        //                                    .rotate(if (window.screen.width < 400) 90.deg else 0.deg)
                                        .backgroundColor(Palette.FieldBackColor.rgbLight)
                                        .overflow(
                                            overflowY = Overflow.Hidden,
                                            overflowX = Overflow.Auto
                                        )
                                        .margin(topBottom = if (window.screen.width < 400) 60.px else 10.px),
                                    contentAlignment = Alignment.Center
                                ) {
                                    //
                                    Box(
                                        modifier = Modifier.width(254.px).height(165.px)
                                            .zIndex(99)
                                    ) {
                                        Row(
                                            modifier = Modifier.fillMaxSize().gap(5.px)
                                                .flexWrap(FlexWrap.Wrap),
                                            verticalAlignment = Alignment.CenterVertically,
                                        ) {
                                            Box(
                                                modifier = Modifier
                                                    .backgroundColor(
                                                        if (playerPosition == "GK Goalkeeper") Palette.AbsoluteGreen.rgbLight
                                                        else if (secondaryPosition == "GK Goalkeeper") Palette.AbsoluteOrange.rgbLight
                                                        else Colors.Transparent
                                                    )
                                                    .width(31.px).height(73.px)
                                            )
                                            Column(
                                                modifier = Modifier.gap(5.px)
                                                    .flexWrap(FlexWrap.Wrap).margin(top = 2.px)
                                            ) {
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "LLD Left Lateral Defender") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "LLD Left Lateral Defender") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(86.px).height(28.px)
                                                )
                                                Row(Modifier.gap(4.px)) {
                                                    Column(Modifier.gap(4.px)) {
                                                        Box(
                                                            modifier = Modifier
                                                                .backgroundColor(
                                                                    if (playerPosition == "LCD Left Central Defender") Palette.AbsoluteGreen.rgbLight
                                                                    else if (secondaryPosition == "LCD Left Central Defender") Palette.AbsoluteOrange.rgbLight
                                                                    else Colors.Transparent
                                                                )
                                                                .width(42.px).height(47.px)
                                                        )
                                                        Box(
                                                            modifier = Modifier
                                                                .backgroundColor(
                                                                    if (playerPosition == "RCD Right Central Defender") Palette.AbsoluteGreen.rgbLight
                                                                    else if (secondaryPosition == "RCD Right Central Defender") Palette.AbsoluteOrange.rgbLight
                                                                    else Colors.Transparent
                                                                )
                                                                .width(42.px).height(45.px)
                                                        )
                                                    }
                                                    Box(
                                                        modifier = Modifier
                                                            .backgroundColor(
                                                                if (playerPosition == "DM Defensive Midfielder") Palette.AbsoluteGreen.rgbLight
                                                                else if (secondaryPosition == "DM Defensive Midfielder") Palette.AbsoluteOrange.rgbLight
                                                                else Colors.Transparent
                                                            )
                                                            .width(40.px).height(96.px)
                                                    )
                                                }
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "RLD Right Lateral Defender") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "RLD Right Lateral Defender") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(86.px).height(28.px)
                                                )
                                            }
                                            Column(
                                                modifier = Modifier.gap(5.px)
                                                    .flexWrap(FlexWrap.Wrap)
                                                    .margin(left = 2.px, top = 2.px)
                                            ) {
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "LW Left Wing") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "LW Left Wing") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(82.px).height(28.px)
                                                )
                                                Row(Modifier.gap(4.px)) {
                                                    Box(
                                                        modifier = Modifier
                                                            .backgroundColor(
                                                                if (playerPosition == "AM Attacking Midfielder") Palette.AbsoluteGreen.rgbLight
                                                                else if (secondaryPosition == "AM Attacking Midfielder") Palette.AbsoluteOrange.rgbLight
                                                                else Colors.Transparent
                                                            )
                                                            .width(43.px).height(96.px)
                                                    )
                                                    Box(
                                                        modifier = Modifier
                                                            .backgroundColor(
                                                                if (playerPosition == "ST Striker") Palette.AbsoluteGreen.rgbLight
                                                                else if (secondaryPosition == "ST Striker") Palette.AbsoluteOrange.rgbLight
                                                                else Colors.Transparent
                                                            )
                                                            .width(43.px).height(96.px)
                                                    )

                                                }
                                                Box(
                                                    modifier = Modifier
                                                        .backgroundColor(
                                                            if (playerPosition == "RW Right Wing") Palette.AbsoluteGreen.rgbLight
                                                            else if (secondaryPosition == "RW Right Wing") Palette.AbsoluteOrange.rgbLight
                                                            else Colors.Transparent
                                                        )
                                                        .width(82.px).height(28.px)
                                                )
                                            }

                                        }
                                    }
                                    Box(
                                        modifier = Modifier.width(254.px).height(165.px)
                                            .backgroundImage(url(Res.Images.field_boundary))
                                            .zIndex(999)
                                            .backgroundSize(BackgroundSize.Cover)
                                            .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
                                    )
                                }

                            }

                        }
                        //                                logo
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.End
                        ) {
                            Image(src = Res.Images.website_logo_zone360_trans)
                        }

                    }
                }

            }
        }
    }
    Input(
        type = InputType.File,
        attrs = {
            id(Res.Id.playerImage)
            attr("accept", "image/*")
            style { display(DisplayStyle.None) }
            onChange { event ->
                val file = (event.target as HTMLInputElement).files?.item(0)

                if (file != null) {
                    isImageUploading = true
                    hasImage = true  // We're uploading a new image
                    isImageLoading = true  // Show shimmer while processing
                    val reader = FileReader()
                    reader.onload = { e ->
                        val base64 = e.target?.asDynamic()?.result as? String
                        if (base64 != null) {
                            uploadedImageUrl = base64 // Optional UI update
                            isImageLoading = false
                        }
                    }
                    reader.readAsDataURL(file)

                    scope.launch {
                        try {
                            isImageUploading = true
                            val response = uploadCoachImage(
                                userID = userId,
                                file = file,
                                organization = AppGlobal.userData.organization

                            )
                            getPlayerInfo = getPlayerInfo.copy(imageUrl = response.data.imageUrl)
                            AppGlobal.userData = AppGlobal.userData.copy(imageUrl = response.data.imageUrl)
                            // Update the full URL after successful upload
                            val fullUrl = "${Res.Images.base_Image_Url}${response.data.imageUrl}?nocache=${getCurrentMilliseconds()}"
                            uploadedImageUrl = fullUrl
                            hasImage = true


                        } catch (e: Exception) {
                            debugPrintln("❌ Player image upload failed: $e")
                        } finally {
                            isImageUploading = false
                            isImageLoading = false
                        }
                    }
                }
            }

        }
    )
}

